import {
  FETCH_WIDGETS_PENDING,
  FETCH_WIDGETS_REJECTED,
  FETCH_WIDGETS_FULFILLED
} from '../constants/widgets';

const initialState = {
  pending: true,
  widget: {},
  error: {}
}

export const widgets = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WIDGETS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_WIDGETS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_WIDGETS_FULFILLED:
      return {
        ...state,
        widget: action.response,
        pending: false,
        error: []
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/widgets.js